<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="modal-header checkout-popup-header">
      <h4 class="modal-title" id="modal-basic-title">
        {{ 'addCart.updatedCart' | cxTranslate }}
      </h4>
    </div>
    <div class="modal-body checkout-popup">
      <h3 class="confirmation-order">
        {{ 'addCart.nonBuyableParts' | cxTranslate }}
      </h3>
      <div
        class="vs-checkbox custom-order-checkbox"
        *ngIf="nonBuyableProducts.length > 0"
      >
        <i class="material-icons custom-material-icon">report_problem</i>
        <p class="confirmation-order">
          <span *ngFor="let item of nonBuyableProducts; let i = index">
            {{ 'addCart.part' | cxTranslate }} {{ item.partNumber
            }}<span *ngIf="i < nonBuyableProducts.length - 1">,</span>
          </span>
          <span> {{ 'addCart.warningMsg' | cxTranslate }} </span>
        </p>
      </div>
    </div>
    <div class="modal-footer checkout-popup-footer">
      <button class="vs-primary-btn" (click)="closeModal('non-buyable-ok')">
        <span>{{ 'addCart.okBtn' | cxTranslate }}</span>
      </button>
    </div>
  </div>
</div>
